// extracted by mini-css-extract-plugin
export default {"FooterWrapper":"nPaOGQ5n","FooterContent":"GOvN8P_v","FooterContainerWide":"mBytGLwz"};